import { PurchasedProduct, LowerPriceProduct } from "@/types/purchasedProduct";
import { getGlobalSessionId, ecsClient } from "@/services";

type GetUserPurchasedProductsResponse = {
  success: boolean;
  message: string;
  products: PurchasedProduct[];
  totalCount: number;
};

type PurchasedProductAnalysisResponse = {
  success: boolean;
  message: string;
  analysis: any;
};

type GetUserLowerPriceProductsResponse = {
  success: boolean;
  message: string;
  lowerPriceProducts: LowerPriceProduct[];
  totalCount: number;
};

type DeletePurchasedProductResponse = {
  success: boolean;
  message: string;
  product: PurchasedProduct;
};

const PurchasedProductServices = {
  getPurchasedProducts: async () => {
    const sessionId = getGlobalSessionId();

    const result = await ecsClient.get<GetUserPurchasedProductsResponse>(
      "/products",
      {
        params: { sessionId },
      }
    );

    return result.data?.products || [];
  },

  analyzeUserEmailForPurchases: async (userId: string) => {
    const result = await ecsClient.post<PurchasedProductAnalysisResponse>(
      "/products/analyze",
      {
        userId,
      }
    );

    return result.data;
  },

  getUserLowerPriceProducts: async () => {
    const sessionId = getGlobalSessionId();

    const result = await ecsClient.get<GetUserLowerPriceProductsResponse>(
      "/products/lower-prices",
      {
        params: { sessionId },
      }
    );

    return result.data?.lowerPriceProducts || [];
  },

  deletePurchasedProduct: async (productName: string, orderNumber: string) => {
    const sessionId = getGlobalSessionId();

    const result = await ecsClient.delete<DeletePurchasedProductResponse>(
      "/products",
      {
        data: {
          sessionId,
          productName,
          orderNumber,
        },
      }
    );

    return result.data;
  },
};

export default PurchasedProductServices;
